export function getNewbuildingIdFromUrl(url: string): number | undefined {
  try {
    const parsed = new URL(url, 'https://www.cian.ru');
    const value = parsed.searchParams.get('newobject');
    const id = value ? Number(value) : NaN;

    return Number.isFinite(id) && id > 0 ? id : undefined;
  } catch {
    return undefined;
  }
}
